export default __webpack_public_path__ + "static/media/WNLogo.0b99f39f.png";